import styled from "styled-components";
import Autocomplete from "@mui/material/Autocomplete";

import { breakpoints } from "@/styles/breakpoints";

import { StyledBrokerNameBase } from "../../styled";

export const StyledBrokerAddress = styled.span`
    font-size: var(--size-14);
    color: var(--color-grey-900);
`;

export const StyledAutoCompleteField = styled(Autocomplete)`
    &.autocomplete-root {
        width: 100%;
    }
    .autocomplete-paper {
        line-height: 1.2 !important;
        ul {
            max-height: 36vh !important;
            @media ${breakpoints.xs} {
                max-height: 28vh !important;
            }
        }
    }
    .autocomplete-input {
        font-style: italic;
    }
`;

export const StyledSearchMinLettersRequired = styled.div`
    align-items: center;
    width: 100%;
    font-size: var(--size-12);
    font-style: normal;
    font-weight: normal;
    line-height: 18px;
    color: var(--color-grey-800);
    text-align: start;
`;

export const StyledBrokerName = styled.span`
    ${StyledBrokerNameBase}
`;
